export const sectionTypes = {
  LIGHT: 'light',
  DARK: 'dark',
  GRADIENT: 'gradient',
};

export const sectionTitles = {
  CLIENT_PROJECTS: 'Client Projects',
  PREVIOUS_EXPERIENCE: 'Previous Experience',
  BACKGROUND: 'Background',
  INFO: 'Info',
};
